var module = angular.module('octopusApp.projects');

module.controller('ChannelsController', function ($scope, busy, $stateParams, projectState, pageTitle, octopusRepository) {
    var isLoading = $scope.isLoading = busy.create();
    var projectId = $stateParams.projectId;

    $scope.lifecycles = [];

    var loadChannels = function(){
        isLoading.promise(octopusRepository.Projects.getChannels($scope.project).then(function (channels) {
            $scope.channels = channels;
        }));
    };

    isLoading.promise(projectState.load().then(function (project) {
        pageTitle(project.Name + " channels");

        $scope.project = project;
        $scope.actionsByName = {};

        isLoading.promise(octopusRepository.DeploymentProcesses.get(project.DeploymentProcessId).then(function (deploymentProcess) {
            $scope.deploymentProcess = deploymentProcess;
            var actions = _.chain(deploymentProcess.Steps).map(function(step){ return step.Actions; }).flatten().value();
            $scope.actionsByName = _.object(_.pluck(actions, "Name"), actions);
        }));

        isLoading.promise(octopusRepository.Lifecycles.get().then(function (lifecycles) {
            _.each(lifecycles.Items, function(lifecycle) {
                $scope.lifecycles[lifecycle.Id] = lifecycle;
            });
        }));

        loadChannels();

        $scope.getActionPackageName = function(actionName){
            var action = $scope.actionsByName[actionName];

            if (!action) {
                return;
            }

            return action.Properties['Octopus.Action.Package.PackageId'];
        };

        $scope.getLifecycleName = function(channel){

            if (Object.keys($scope.lifecycles).length === 0) {
                return null;
            }
      
            if (channel.LifecycleId) {
                return $scope.lifecycles[channel.LifecycleId].Name;
            }

            return $scope.lifecycles[$scope.project.LifecycleId].Name;
        };
    }));
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/channels_controller.js
// module id = 509
// module chunks = 1